import React from 'react';
import './QuestionDisplay.css';

const QuestionDisplay = ({ question }) => {
  return (
    <div className="question-display">
      {question.type === 'image-text' && question.questionImage ? (
        <div className="question-with-image">
          <div className="question-image-container">
            <img 
              src={question.questionImage} 
              alt="سؤال بصري" 
              className="question-image"
              onError={(e) => {
                e.target.src = 'https://placehold.co.com/400x300?text=صورة+غير+متوفرة';
              }}
            />
          </div>
          <div className="question-text">
            <h2>{question.question}</h2>
          </div>
        </div>
      ) : (
        <div className="question-text-only">
          <h2>{question.question}</h2>
        </div>
      )}
    </div>
  );
};

export default QuestionDisplay;
